import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  translationConstants,
  paymentType,
  centerTabsConstants,
  roles,
  StorageKeys,
  CenterStatusEnum,
  initialGridStateForParams,
} from "../../../../constants";
import { useTranslation } from "react-i18next";
import GeneralTab from "./Tabs/GeneralTab";
import LocationsTab from "./Tabs/LocationsTab";
import MembershipTab from "./Tabs/MembershipTab";
import InstrctorsTab from "./Tabs/InstructorsTab";
import {
  getUserPayload,
  moveBack,
  getLocalStorageItem,
} from "../../../../system";
import { paymentActions, centersActions } from "../../../../redux/actions";
import BTN_BACK from "../../../../assets/images/icon/arrow-left.svg";
import { Button, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const CenterProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const userPayload = getUserPayload();

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData.user.centerId
  );
  const paymentHistory = useSelector(
    (state) => state.PaymentReducer.paymentHistory?.pageData
  );
  const centerProfileData = useSelector(
    (state) => state.centersReducer.centerProfileData
  );
  const urlParams = new URLSearchParams(window.location.search);
  const [tabFromURL, setTabFromURL] = useState(
    new URLSearchParams(location?.search)?.get("tab")
  );
  const isAdmin =
    getLocalStorageItem(StorageKeys.activeRole) === roles.SuperAdmin ||
    getLocalStorageItem(StorageKeys.activeRole) === roles.Admin;
  const centerId = urlParams.get("centerId") || systemUserId;

  const [key, setKey] = useState(centerTabsConstants.CENTER_GENERAL);

  useEffect(() => {
    if (userPayload?.user?.role === roles.Center) {
      dispatch(
        paymentActions.paymentHistory({
          centerId: centerId,
          paymentType: paymentType.Center,
          params: initialGridStateForParams,
        })
      );
    }
    /*eslint-disable-next-line */
  }, []);

  useEffect(() => {
    if (tabFromURL) {
      setKey(centerTabsConstants.CENTER_MEMBERSHIP);
      setTabFromURL(null);
    }
    /*eslint-disable-next-line */
  }, [tabFromURL]);

  return (
    <>
      <div className="user-profile">
        {isAdmin ? (
          <div className="m-3">
            <span className="cursor-pointer" onClick={moveBack}>
              <img src={BTN_BACK} className="rotated-element" />
            </span>
          </div>
        ) : (
          ""
        )}
        <Tabs
          id="center-profile-controller"
          selectedIndex={key}
          onSelect={(k) => setKey(k)}
        >
          <Row className="d-flex justify-content-between">
            <Col sm={8}>
              <TabList>
                <Tab eventKey={centerTabsConstants.CENTER_GENERAL}>
                  {t(translationConstants.GENERAL_TAB)}
                </Tab>
                <Tab eventKey={centerTabsConstants.CENTER_LOCATION}>
                  {t(translationConstants.LOCATIONS)}
                </Tab>
                {paymentHistory?.length > 0 && (
                  <Tab eventKey={centerTabsConstants.CENTER_MEMBERSHIP}>
                    {t(translationConstants.PAYMENT)}
                  </Tab>
                )}
                <Tab eventKey={centerTabsConstants.CENTER_INSTRUCTORS}>
                  {t(translationConstants.INSTRUCTOR)}
                </Tab>
              </TabList>
            </Col>

            {!isAdmin &&
              centerProfileData?.centerStatus === CenterStatusEnum.Rejected && (
                <Col sm={12} md="auto">
                  <div className="d-flex justify-content-end py-3 px-3">
                    <div className="d-flex flex-column align-items-end">
                      <Button
                        className="btn-submit new-green-color"
                        onClick={() => {
                          dispatch(
                            centersActions.centerReApprovalRequest(
                              centerId,
                              () => {
                                dispatch(
                                  centersActions.getCenterById(centerId)
                                );
                              }
                            )
                          );
                        }}
                      >
                        {t(translationConstants.RESEND_REQUEST)}
                      </Button>
                      <p className="fst-italic">
                        {`*${t(
                          translationConstants.RESEND_REQUEST_FOR_CENTER_APPROVAL
                        )}`}
                      </p>
                    </div>
                  </div>
                </Col>
              )}
          </Row>

          <TabPanel>
            <GeneralTab
              generalClassName={"general-tab"}
              isAdmin={isAdmin}
              centerId={centerId}
              setKey={setKey}
            />
          </TabPanel>
          <TabPanel>
            <LocationsTab isAdmin={isAdmin} centerId={centerId} />
          </TabPanel>
          {paymentHistory?.length > 0 && (
            <TabPanel>
              <MembershipTab
                isAdmin={isAdmin}
                centerId={centerId}
                centerStatus={centerProfileData?.centerStatus}
              />
            </TabPanel>
          )}
          <TabPanel>
            <InstrctorsTab centerId={centerId} />
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default CenterProfile;
